module.exports = __webpack_public_path__ + "static/fonts/iconfont.47c2cd70.woff";